import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './main/not-found/not-found.component';
import { SuccessPageComponent } from './main/success-page/success-page.component';
import { CheckoutPageComponent } from './main/checkout-page/checkout-page.component';
import { CollectEmailComponent } from './main/collect-email/collect-email.component';
import { AwaitingPaymentComponent } from './main/awaiting-payment/awaiting-payment.component';
import { OrderSuccessfulComponent } from './main/order-successful/order-successful.component';

const routes: Routes = [
  {
    path: 'orders',
    loadChildren: () =>
      import('./orders/orders.module').then((m) => m.OrdersModule),
  },
  {
    path: 'checkout',
    component: CheckoutPageComponent,
  },
  {
    path: 'collect-email',
    component: CollectEmailComponent,
  },
  {
    path: 'awaiting-payment',
    component: AwaitingPaymentComponent,
  },
  {
    path: 'order-successful',
    component: OrderSuccessfulComponent,
  },
  {
    path: 'success',
    component: SuccessPageComponent,
  },
  {
    path: ':id',
    loadChildren: () =>
      import('../app/main/main.module').then((m) => m.MainModule),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
